import { useMutation } from 'react-query';
import http from '../http';
import { MerchantConnectCreateUpdateStampCardPayload } from './types';

// to create stamp card on merchant connect
const merchantConnectCreateStampCard = (payload: FormData) =>
  http.post<MerchantConnectCreateUpdateStampCardPayload>(
    '/v1/mc_products',
    payload,
  );

export const useMerchantConnectCreateStampCard = () =>
  useMutation(merchantConnectCreateStampCard);
